export type PasswordRule = {
  id: 'length' | 'uppercase' | 'digit' | 'special';
  label: string;
  /** Rules the form enforces; the others are only recommended. */
  required: boolean;
  test: (value: string) => boolean;
};

/** Requirements list of the Figma „Requirements“ block (60260:29908). */
export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'Aspoň 8 znakov', required: true, test: value => value.length >= 8 },
  { id: 'uppercase', label: 'Veľké písmeno', required: true, test: value => /\p{Lu}/u.test(value) },
  { id: 'digit', label: 'Číslo', required: true, test: value => /\d/.test(value) },
  {
    id: 'special',
    label: 'Špeciálny znak (odporúčané)',
    required: false,
    test: value => /[^\p{L}\d\s]/u.test(value),
  },
];

export type PasswordStrengthLevel = 0 | 1 | 2 | 3 | 4;

export const PASSWORD_STRENGTH_LABELS = [
  '',
  'Veľmi slabé',
  'Slabé',
  'Stredne silné',
  'Silné',
] as const;

/** Number of met rules – the filled bars of the strength meter. */
export function passwordStrength(value: string): PasswordStrengthLevel {
  return PASSWORD_RULES.filter(rule => rule.test(value)).length as PasswordStrengthLevel;
}

export function meetsRequiredPasswordRules(value: string) {
  return PASSWORD_RULES.every(rule => !rule.required || rule.test(value));
}
